import { CARD_STATUS, LOCK_TYPE } from "./constants";

const convertToShortDate = (longDateStr) => {
  const date = new Date(longDateStr);
  const dateStr = `
    ${date.toLocaleString('default', { month: 'short' })}
    ${date.getDate()},
    ${date.getFullYear()}
  `;
  return dateStr;
};

const isUserRiskLocked = (userLockedStatus) => {
  return userLockedStatus
    ? userLockedStatus?.card?.status === CARD_STATUS.LOCKED &&
        [LOCK_TYPE.RISK, LOCK_TYPE.RISK_ACTIVE, LOCK_TYPE.RISK_INACTIVE].includes(userLockedStatus?.lock_type)
    : false;
};

export { convertToShortDate, isUserRiskLocked };
